
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import displayINRCurrency from "../helpers/displayCurrency";
import { motion } from "framer-motion";
import {
  FaBoxOpen,
  FaRupeeSign,
  FaTruck,
  FaCheckCircle,
  FaDownload,
  FaTimes,
} from "react-icons/fa";

const OrderDetails = () => {

  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    fetchOrder();
  }, []);

  const fetchOrder = async () => {
    const res = await fetch(
      `https://lappyshop.onrender.com/api/order/${id}`,
      { credentials: "include" }
    );

    const data = await res.json();
    if (data.success) setOrder(data.data);
  };

  // 🔥 CANCEL
  const handleCancel = async () => {
    if (!window.confirm("Cancel this order?")) return;

    const res = await fetch(
      `https://lappyshop.onrender.com/api/cancel-order/${id}`,
      {
        method: "PUT",
        credentials: "include",
      }
    );

    const data = await res.json();

    if (data.success) {
      fetchOrder();
      alert("Order Cancelled ❌");
    }
  };
const navigate = useNavigate();
const isReturnAllowed = () => {
  if (order.orderStatus !== "delivered") return false;

  const deliveredDate = new Date(order.updatedAt);
  const diffDays = (Date.now() - deliveredDate.getTime()) / (1000 * 60 * 60 * 24);

  return diffDays <= 7;
};
  const handleInvoice = () => {
    window.print();
  };

  if (!order) return null;

  const steps = ["processing","shipped","out_for_delivery","delivered"];
  const current = steps.indexOf(order.orderStatus);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0f172a] to-black text-white p-4">

      <div className="max-w-6xl mx-auto">

        <h1 className="text-2xl font-bold mb-6">Order Details</h1>

        {/* 🔥 CARD */}
        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 shadow-xl">

          {/* 🔥 ACTION ROW */}
          <div className="flex justify-between flex-wrap gap-3 mb-6">

            <div className="flex gap-3">
              <button className="bg-blue-500 px-4 py-2 rounded-lg text-sm hover:scale-105">
                Track
              </button>

              <button
                onClick={handleInvoice}
                className="bg-black px-4 py-2 rounded-lg flex items-center gap-2"
              >
                <FaDownload /> Invoice
              </button>
            </div>

{isReturnAllowed() && (
  <button
    onClick={() => {
      console.log("ORDER DATA 👉", order);

      const orderId = order?._id || order?.[0]?._id;

      if (!orderId) {
        alert("Order Id Missing ❌");
        return;
      }

      navigate(`/return/${orderId}`);
    }}
    className="bg-yellow-500 px-4 py-2 rounded-lg text-sm hover:bg-yellow-600"
  >
    Return
  </button>
)}

            {order.orderStatus !== "cancelled" && (
              <button
                onClick={handleCancel}
                className="bg-red-500 px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-red-600"
              >
                <FaTimes /> Cancel Order
              </button>
            )}
          </div>

          {/* 🔥 STATUS BOX */}
          <div className="grid md:grid-cols-2 gap-4 mb-6">

            <div className="bg-white/10 p-4 rounded-xl flex gap-3">
              <FaTruck className="text-blue-400" />
              <div>
                <p className="text-xs text-gray-300">Payment</p>
                <p className="font-semibold">
                  {order.paymentMethod} ({order.paymentStatus})
                </p>
              </div>
            </div>

            <div className="bg-white/10 p-4 rounded-xl flex gap-3">
              <FaCheckCircle className="text-green-400" />
              <div>
                <p className="text-xs text-gray-300">Status</p>
                <p className="font-semibold capitalize">
                  {order.orderStatus}
                </p>
              </div>
            </div>

          </div>

          {/* 🔥 NEW TIMELINE */}
          <div className="mb-8">

            <div className="flex justify-between relative">

              {steps.map((step, index) => (
                <div key={step} className="flex flex-col items-center flex-1">

                  <motion.div
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    className={`w-10 h-10 flex items-center justify-center rounded-full font-bold
                    ${
                      index <= current
                        ? "bg-green-500"
                        : "bg-white/20"
                    }`}
                  >
                    {index + 1}
                  </motion.div>

                  <p className="text-xs mt-2 capitalize text-center">
                    {step.replaceAll("_"," ")}
                  </p>

                </div>
              ))}

              <div className="absolute top-5 left-0 w-full h-[2px] bg-white/20 -z-10"></div>

            </div>

          </div>

          {/* 🔥 PRODUCTS */}
          <h2 className="mb-4 font-semibold flex gap-2 items-center">
            <FaBoxOpen /> Items
          </h2>

          <div className="space-y-3">

            {order.items.map((item) => (
              <motion.div
                key={item._id}
                whileHover={{ scale: 1.02 }}
                className="flex gap-4 bg-white/10 p-4 rounded-xl"
              >

                <img
                  src={item.productId.productImage?.[0]}
                  className="w-16 h-16 object-contain"
                />

                <div className="flex-1">
                  <p className="font-medium">
                    {item.productId.productName}
                  </p>
                  <p className="text-sm text-gray-400">
                    Qty: {item.quantity}
                  </p>
                </div>

                <p className="text-green-400 font-semibold">
                  {displayINRCurrency(item.price * item.quantity)}
                </p>

              </motion.div>
            ))}

          </div>

          {/* 🔥 TOTAL */}
          <div className="border-t border-white/20 mt-6 pt-4 flex justify-between text-lg font-bold">
            <span className="flex gap-2 items-center">
              <FaRupeeSign /> Total
            </span>

            <span className="text-green-400">
              {displayINRCurrency(order.totalAmount)}
            </span>
          </div>

        </div>

      </div>

    </div>
  );
};

export default OrderDetails;